import {
  PayoutSettings,
  PayoutSettingsList,
  PayoutSettingsSubjectAllOfType
} from "@wingspanhq/wingspan-api-sdk";

export const selectorOwnPayoutSettings = (
  list?: PayoutSettingsList
): PayoutSettings | undefined =>
  list?.data?.find(
    payoutSettings =>
      payoutSettings.subject.type === PayoutSettingsSubjectAllOfType.ACCOUNT
  );
